export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        'SCHOOL_TEMPLATE',
        data => ({
            id: data.id,
            name: data.name,
            logo: data.logo,
            verified: data.verified,
        }),
    ],
    GET: {},
    POST: {},
};
